import { configureStore } from '@reduxjs/toolkit';
import { authApi } from '../services/authApi';
import { dashboardApi } from '../services/dashboardApi';
import { roleApi } from '../services/roleApi';
import { onboardingApi } from '../services/onboardingApi';
import { orgApi } from '../services/orgApi';
import authReducer from './authSlice';
import basicDetailsReducer from './basicDetailsSlice';
import addEmployeeReducer from './addEmployeeSlice';
import uiReducer from './uiSlice';
import { rtkQueryErrorLogger } from './middleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    basicDetails: basicDetailsReducer,
    addEmployee: addEmployeeReducer,
    ui: uiReducer,
    [authApi.reducerPath]: authApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [orgApi.reducerPath]: orgApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['basicDetails/setEmploymentList', 'basicDetails/setEducationList'],
        ignoredPaths: ['basicDetails.employmentList', 'basicDetails.educationList'],
      },
    }).concat(
      authApi.middleware,
      dashboardApi.middleware,
      roleApi.middleware,
      onboardingApi.middleware,
      orgApi.middleware,
      rtkQueryErrorLogger
    ),
});

export * from './authSlice';
export * from './basicDetailsSlice';
export * from './addEmployeeSlice';
